import type {FC} from 'react';

import {Observer} from 'mobx-react';

import {useI18n} from '@yourcoach/i18n';

import type {ProgramExpandedCommon} from '../../../../api/program';

import LoginSVG from '../../../../assets/icons/primary/Login.svg';
import TimeSVG from '../../../../assets/icons/primary/Time Circle.svg';
import {Button} from '../../../../uikit/Button';
import {useMobxStore} from '../../../../utils/store';
import {JoinIndividualProgramStore} from '../../stores/JoinIndividualProgram';

type Props = {
  onClick: () => void;
  program: ProgramExpandedCommon;
};

export const JoinIndividualProgramButton: FC<Props> = ({onClick, program}) => {
  const {t} = useI18n();
  const store = useMobxStore(() => new JoinIndividualProgramStore({program}));

  return (
    <Observer>
      {() =>
        store.isClientAbleToJoin ? (
          <Button icon={LoginSVG} onClick={onClick} scheme={'secondary'}>
            {store.isClientInvited
              ? t('shared:accept_and_join')
              : t('shared:request_to_join')}
          </Button>
        ) : store.hasRequestBeenSent ? (
          <Button disabled icon={TimeSVG} scheme={'secondary'}>
            {t('shared:request_has_been_sent')}
          </Button>
        ) : null
      }
    </Observer>
  );
};
